const KInputField = (props) => {
    const {value, placeholder, onChange, label} = props;
  return (
    <div className="form-group">
      <label for={`input-${label}`}>{label}</label>
      <input
        type="text"
        className="form-control bg-gray"
        id={`input-${label}`}
        placeholder={placeholder}
        onChange={(e) => {
          //const numericValue = e.target.value.replace(/[^A-Za-z0-9]/g, "");
          //e.target.value = numericValue;
          onChange(e.target.value)
        }}
        value={value}
      />
    </div>
  );
};
export default KInputField;
